<template>
  <SideModal
    :show="show"
    @update:show="$emit('update:show', $event)"
    close-on-overlay-click
    location="right"
  >
    <div>
      <div class="d-flex justify-end p-2">
        <v-btn color="normal" icon @click="$emit('update:show', false)"
          ><v-icon>mdi-close</v-icon></v-btn
        >
      </div>
      <div class="con">
        <div
          class="title accordion"
          data-cy="event-options-accordion-toggler"
          @click="state.openAccordion = !state.openAccordion"
        >
          <span>Options</span>
          <v-icon>{{ state.openAccordion ? "mdi-menu-down" : "mdi-menu-right" }}</v-icon>
        </div>
        <div
          data-cy="options-accordion"
          :class="['item', 'mt-3', 'accordion-field', { 'hidden-accordion': !state.openAccordion }]"
        >
          <div tabindex="1">
            <v-checkbox
              color="primary"
              class="custom-input checkbox"
              label="Allow Comments"
              v-model="confStore.selected!.allow_comments"
              data-cy="event-option-allow_comments"
            >
            </v-checkbox>
            <v-tooltip activator="parent" location="bottom">
              Allow the parents to add a comment on each of their meetings
            </v-tooltip>
          </div>
          <div tabindex="1">
            <v-checkbox
              color="primary"
              class="custom-input checkbox"
              label="One Meeting / Household"
              v-model="confStore.selected!.link_household"
              data-cy="event-option-one_per_household"
            ></v-checkbox>
            <v-tooltip activator="parent" location="bottom">
              Prevent co-parents from making an appointment<br />
              with the same teacher for the same child
            </v-tooltip>
          </div>
          <div tabindex="1">
            <v-checkbox
              color="primary"
              class="custom-input checkbox"
              label="Enable Show More Teachers Button"
              v-model="confStore.selected!.show_more_teachers"
              data-cy="event-option-show_more_teachers"
            ></v-checkbox>
            <v-tooltip activator="parent" location="bottom">
              Allow parents to book meetings <br />with teachers that are not connected to their
              children
            </v-tooltip>
          </div>
          <div tabindex="1">
            <v-checkbox
              color="primary"
              class="custom-input checkbox"
              label="Enable Request Translator"
              v-model="confStore.selected!.request_translator"
              data-cy="event-option-request_translator"
            ></v-checkbox>
            <v-tooltip activator="parent" location="bottom">
              Allow parents to request a translator for their meetings
            </v-tooltip>
          </div>
          <div v-if="confStore.selected!.request_translator" tabindex="1">
            <v-select
              color="primary"
              class="custom-input"
              density="compact"
              chips
              closable-chips
              multiple
              label="Supported Translator Languages"
              :items="languageItems"
              v-model="confStore.selected!.translator_languages"
              data-cy="event-option-translator_languages"
              :menu-props="{ ['data-cy' as string]: 'translator_languages-select-menu' }"
            ></v-select>
            <v-tooltip activator="parent" location="bottom">
              Select which languages parents can request for translation
            </v-tooltip>
          </div>
          <v-checkbox
            color="primary"
            class="custom-input checkbox"
            label="Hide Schedules Without Availability"
            v-model="confStore.selected!.hide_schedules_without_meetings"
            data-cy="event-option-hide_without_availability"
          ></v-checkbox>
          <div tabindex="1">
            <v-checkbox
              v-model="confStore.selected!.require_invite"
              class="custom-input checkbox"
              label="Make Event Private"
              data-cy="event-option-make_private"
            ></v-checkbox>
            <v-tooltip activator="parent" location="bottom">
              Limit the event to specific parents
            </v-tooltip>
          </div>
          <div class="title ml-3 mb-3 mt-5" tabindex="1" >
            <span style="flex-shrink: 0; min-width: 140px">Parent Limit<br /><small style="font-weight: 400; font-size: 0.75em; color: gray">per teacher/team per child</small></span>
            <v-select
              color="primary"
              density="compact"
              class="custom-input"
              style="min-width: 160px"
              :items="[
                { title: 'No Limit', value: 'none' },
                { title: '1 Per Day', value: 'per_day' },
                { title: '1 Per Event', value: 'per_conference' }
              ]"
              v-model="confStore.selected!.parent_booking_limit"
              data-cy="event-option-parent_booking_limit"
              :menu-props="{
                ['data-cy' as string]: 'parent_booking_limit-select-menu'
              }"
            ></v-select>
            <v-tooltip activator="parent" location="bottom">
              Limit parents to one appointment per teacher/team per child.<br />
              "No Limit" allows multiple bookings. "1 Per Day" limits to one per conference day.<br />
              "1 Per Conference" limits to one across the entire event.<br />
              This does not apply to admins or teachers making bookings on behalf of parents.
            </v-tooltip>
          </div>
          <div class="title mt-5 mb-3">
            <span>Restrict By</span>
            <v-select
              color="primary"
              density="compact"
              class="custom-input"
              :items="[
                { title: 'Event', value: 'conference' },
                { title: 'Date', value: 'date' }
              ]"
              v-model="confStore.selected!.restrict_double_bookings_by"
              data-cy="event-option-restrict_by"
              :menu-props="{
                ['data-cy' as string]:'restrict_by-select-menu'
              }"
            ></v-select>
          </div>
          
          <div class="title ml-3">
            <v-switch
              color="primary"
              class="custom-input checkbox"
              label="Max Meeting Parent"
              :model-value="!!confStore.selected!.max_parent_meetings"
              @update:model-value="
                if (confStore.selected!.max_parent_meetings)
                  confStore.selected!.max_parent_meetings = 0;
                else confStore.selected!.max_parent_meetings = 1;
              "
              data-cy="event-option-restrict_by_parent"
            ></v-switch>
            <v-tooltip activator="parent" location="bottom">
              number of meetings a parent can make <br />during the entire conference or each day
            </v-tooltip>
            <v-text-field
              v-if="confStore.selected!.max_parent_meetings"
              style="max-width: 80px"
              type="number"
              density="compact"
              color="primary"
              class="custom-input"
              :model-value="confStore.selected!.max_parent_meetings"
              @update:model-value="
                if (+$event && +$event > 0) confStore.selected!.max_parent_meetings = +$event;
              "
              data-cy="event-option-restrict_by_parent_input"
            ></v-text-field>
            <span v-else style="color: gray; font-weight: 400">Unlimited</span>
          </div>
          <div class="title ml-3">
            <v-switch
              color="primary"
              class="custom-input checkbox"
              label="Max Meeting Child"
              :model-value="!!confStore.selected!.max_children_meetings"
              @update:model-value="
                if (confStore.selected!.max_children_meetings)
                  confStore.selected!.max_children_meetings = 0;
                else confStore.selected!.max_children_meetings = 1;
              "
              data-cy="event-option-restrict_by_child"
            ></v-switch>
            <v-tooltip activator="parent" location="bottom">
              number of meetings a parent can make for each of their children,<br />during the
              entire conference or each day
            </v-tooltip>
            <v-text-field
              v-if="!!(confStore.selected!.max_children_meetings)"
              style="max-width: 80px"
              type="number"
              density="compact"
              color="primary"
              class="custom-input"
              :model-value="confStore.selected!.max_children_meetings"
              @update:model-value="
                if (+$event && +$event > 0) confStore.selected!.max_children_meetings = +$event;
              "
              data-cy="event-option-restrict_by_child_input"
            ></v-text-field>
            <span v-else style="color: gray; font-weight: 400">Unlimited</span>
          </div>
          <v-btn
            @click="save"
            style="align-self: flex-end"
            class="mt-3"
            :loading="state.loadingSave"
            data-cy="event-options-save-btn"
            >save</v-btn
          >
        </div>
        <div
          class="mt-3"
          v-if="confStore.selected!.require_invite"
          data-cy="event-option-invite_parents_con"
        >
          <div class="title accordion mb-4" @click="state.openAccordion = !state.openAccordion">
            <span>Invited Parents</span>
          </div>
          <v-text-field
            label="Search"
            color="primary"
            append-inner-icon="mdi-magnify"
            v-model="state.search"
          >
          </v-text-field>
          <div class="table-overflow-hide">
            <div class="directoryTable scrollable-55vh" style="max-height: 45vh; height: auto">
              <table class="table">
                <thead class="sticky-header">
                  <tr>
                    <th>Parent Name</th>
                    <th class="small-col">
                      <v-checkbox
                        style="
                          max-width: max-content;
                          max-height: 24px;
                          overflow: hidden;
                          display: flex;
                          align-items: center;
                        "
                        class="custom-input"
                        density="compact"
                        :model-value="filteredRows.length && filteredRows.every((r) => r.allowed)"
                        @update:model-value="
                          {
                            if (filteredRows.length && filteredRows.every((r) => r.allowed)) {
                              filteredRows.forEach((p) =>
                                setParentData(parentsData.filter((i) => i.uid !== p.uid))
                              );
                            } else
                              filteredRows.forEach(
                                (p) =>
                                  !p.allowed &&
                                  parentsData.push({
                                    uid: p.uid
                                  })
                              );
                          }
                        "
                        data-cy="event-option-invite_parents_select_all_parents"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody v-if="!loadingParents">
                  <template v-for="parent in paginatedResults" :key="parent.uid">
                    <tr>
                      <td style="width: 100%">{{ parent.firstname }} {{ parent.lastname }}</td>
                      <td>
                        <v-checkbox
                          style="
                            max-width: max-content;
                            max-height: 24px;
                            overflow: hidden;
                            display: flex;
                            align-items: center;
                          "
                          class="custom-input"
                          density="compact"
                          :model-value="parent.allowed"
                          @update:model-value="
                            if (!parent.allowed)
                              parentsData.push({
                                uid: parent.uid
                              });
                            else setParentData(parentsData.filter((i) => i.uid !== parent.uid));
                          "
                          data-cy="event-options-make_private-select-parent"
                        ></v-checkbox>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
              <div v-if="loadingParents">
                <LoadingState text="Loading Parents"></LoadingState>
              </div>
            </div>
          </div>
          <Pagination :per-page-arr="[50, 100]" v-bind="forComponent()"></Pagination>
          <v-btn
            style="text-transform: capitalize; width: 100px"
            class="mt-3"
            :loading="state.loadingParents"
            @click="saveParents"
            data-cy="event-options-private-save"
            >Save</v-btn
          >
        </div>
      </div>
    </div>
    <div class="actions p-3 d-flex justify-space-between"></div>
  </SideModal>
</template>

<script setup lang="ts">
import LoadingState from "@/components/loadingState.vue";
import Pagination from "@/components/pagination.vue";
import SideModal from "@/components/sideModal.vue";
import usePaginate from "@/hooks/usePaginate";
import FetchService from "@/services/fetch.service";
import { useAlertsStore } from "@/stores/alerts";
import useParents from "@/stores/school/parents";
import { useConferenceStore } from "@/stores/teacher/conference";
import { complexSearch } from "@/utils";
import { sort } from "@/utils/sort";
import { computed, reactive, ref, watch, onBeforeUnmount } from "vue";
  import { SUPPORTED_LANGUAGES } from "@/composables/useLanguage.js";
defineProps<{
  show: boolean;
}>();

defineEmits<{
  (e: 'update:show', ...args: any[]): void
}>();

const confStore = useConferenceStore();
const parentsS = useParents();

const state = reactive({
  loadingSave: false,
  search: "",
  loadingParents: false,
  openAccordion: !confStore.selected?.require_invite
});

watch(
  () => confStore.selected,
  () => {
    if (confStore.selected?.require_invite) state.openAccordion = false;
  }
);

const parentsData = ref<{ uid: string }[]>([]);
const loadingParents = ref(false);

let controller: AbortController | null = null;

const loadInvitedParents = async () => {
  if (!confStore.selected?.conference_id) {
    parentsData.value = [];
    return;
  }
  controller?.abort();
  controller = new AbortController();
  loadingParents.value = true;
  try {
    const res: any = await FetchService.fetchData(
      `/conferences/${confStore.selected.conference_id}`,
      "get",
      undefined,
      undefined,
      controller
    );
    parentsData.value = res && Array.isArray(res?.parents) ? (res.parents as { uid: string }[]) : [];
  } catch (e) {
    parentsData.value = [];
  } finally {
    loadingParents.value = false;
  }
};

watch(
  () => confStore.selected?.conference_id,
  () => loadInvitedParents(),
  { immediate: true }
);

onBeforeUnmount(() => controller?.abort());

const setParentData = (data: { uid: string }[]) => {
  parentsData.value = data;
};

const parentsTable = computed(() => {
  return sort(
    parentsS.parents.data.map((g) => ({
      firstname: g.firstname,
      lastname: g.lastname,
      uid: g.uid,
      allowed: !!parentsData.value.find((g2) => g2.uid === g.uid)
    })),
    (i) => i.lastname
  );
});

const languageItems = computed(() =>
  SUPPORTED_LANGUAGES.map((l) => ({ title: l.nativeName || l.name, value: l.code }))
);

watch(
  () => confStore.selected?.request_translator,
  (enabled) => {
    if (enabled && confStore.selected && !Array.isArray(confStore.selected.translator_languages)) {
      confStore.selected.translator_languages = [];
    }
  },
  { immediate: true }
);

const filteredRows = computed(() => {
  return parentsTable.value.filter((i) => {
    return complexSearch(state.search, `${i.firstname} ${i.lastname} ${i.uid}`);
  });
});
const { paginatedResults, forComponent } = usePaginate(filteredRows);

const save = async () => {
  state.loadingSave = true;
  const res = await confStore.apiUpdateConference(confStore.selected!.conference_id, {
    allow_comments: confStore.selected!.allow_comments,
    link_household: confStore.selected!.link_household,
    show_more_teachers: confStore.selected!.show_more_teachers,
    request_translator: confStore.selected!.request_translator,
    translator_languages: confStore.selected!.translator_languages,
    hide_schedules_without_meetings: confStore.selected!.hide_schedules_without_meetings,
    zoom_auto_create: confStore.selected!.zoom_auto_create,
    restrict_double_bookings_by: confStore.selected!.restrict_double_bookings_by,
    max_children_meetings: confStore.selected!.max_children_meetings,
    max_parent_meetings: confStore.selected!.max_parent_meetings,
    require_invite: confStore.selected!.require_invite,
    parent_booking_limit: confStore.selected!.parent_booking_limit
  });
  if (res.conference_id)
    confStore.updatedConference(res.conference_id, {
      allow_comments: res.allow_comments,
      link_household: res.link_household,
      show_more_teachers: res.show_more_teachers,
      request_translator: res.request_translator,
      translator_languages: res.translator_languages,
      hide_schedules_without_meetings: res.hide_schedules_without_meetings,
      zoom_auto_create: res.zoom_auto_create,
      restrict_double_bookings_by: res.restrict_double_bookings_by,
      max_children_meetings: res.max_children_meetings,
      max_parent_meetings: res.max_parent_meetings,
      require_invite: res.require_invite,
      parent_booking_limit: res.parent_booking_limit
    });
  state.loadingSave = false;
};

const saveParents = async () => {
  state.loadingParents = true;

  const parents = parentsData.value.map((p) => p.uid);
  const res = await confStore.apiUpdateConference(confStore.selected!.conference_id, {
    require_invite: confStore.selected!.require_invite
  });
  if (res.conference_id) {
    confStore.updatedConference(res.conference_id, {
      require_invite: res.require_invite
    });
    const res2 = await FetchService.fetchData(
      `/parent-conference/${confStore.selected!.conference_id}`,
      "post",
      { parents }
    );
    if (!res2?.status) {
      useAlertsStore().addAlert("error", "Failed to save parents, please try again later");
    }
  } else {
    useAlertsStore().addAlert("error", "Failed to make event private, please try again later");
  }
  state.loadingParents = false;
};
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;

.con {
  padding: 0 40px 40px 40px;

  .accordion-field {
    margin-bottom: 60px;
    transition: max-height 0.2s linear, margin 0.2s linear;
   // max-height: 600px;
    overflow: hidden;
    &.hidden-accordion {
      // animation: accordion 0.2s linear reverse forwards;
      max-height: 0px;
      margin-bottom: 20px;
    }
  }

  .title {
    &.accordion {
      cursor: pointer;
    }

    span {
      color: $primary;
      font-size: 1.1rem;
      font-weight: 600;
    }
    display: flex;
    align-items: center;
    gap: 10px;
    justify-content: space-between;
    .custom-input {
      max-width: fit-content;
    }
  }
  .custom-input {
    &.checkbox:deep(.v-selection-control) {
      min-height: 0px !important;
    }
  }
}

.item {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
</style>
